import React, { FC } from 'react';
import { Carousel } from '@one-thd/sui-carousel';
import { IGiftCardCommonData } from '../../models/common-models';
import { GiftCardBarcode } from './gift-card-barcode';

interface GiftCardBarcodeCarouselProps {
  giftCardsList: Array<IGiftCardCommonData>;
  onClose: () => void;
}

export const GiftCardBarcodeCarousel: FC<GiftCardBarcodeCarouselProps> = ({
  giftCardsList,
  onClose
}) => {

  return (
    // eslint-disable-next-line @harmony/stencil/no-tailwind-disable
    // eslint-disable-next-line tailwindcss/no-custom-classname
    <div id="controlled-carousel" className="controlled-carousel" data-testid="controlled-carousel-container">
      <Carousel
        layout="full-bleed"
        type="peekless"
        disableMargin
        loop={false}
        slidesPerView={1}
        shadow={false}
        containerId="controlled-carousel"
      >
        {giftCardsList.map((giftCard) => (
          <GiftCardBarcode key={giftCard.id} giftCard={giftCard} onClose={onClose} />
        ))}
      </Carousel>
    </div>
  );
};
